import { connect } from 'react-redux';
import { TopBarDropdown } from './component';
import {
  clearTopBarExpendedMenu,
  updateTopBarExpendedMenuAlignment,
} from '../../../../ReduxStorage/TopBar/dispatchers';
import {
  selectTopBarExpandedMenuAlignment,
  selectTopBarExpandedMenu,
} from '../../../../ReduxStorage/TopBar/selectors';
import { catchErrors } from '../../../components/ErrorBoundary/component';

function mapStateToProps(state) {
  return {
    expandedMenu: selectTopBarExpandedMenu(state),
    computedAlignment: selectTopBarExpandedMenuAlignment(state),
  };
}

function mapDispatchToProps(dispatch) {
  return {
    clearTopBarExpendedMenu: () => dispatch(clearTopBarExpendedMenu()),
    updateTopBarExpendedMenuAlignment: (args) => {
      dispatch(updateTopBarExpendedMenuAlignment(args));
    },
  };
}

export const ConnectorTopBarDropdown = catchErrors(
  connect(mapStateToProps, mapDispatchToProps)(TopBarDropdown)
);
